import { useState } from "react";
import styles from "./DirectionAnalysis.module.css";
import ContentTitle from "../ContentTitle";
import { AccessibilityState, ContentList } from "../../../../screens/MapScreen";

import TransportSelector, { TransportMode } from "./TransportSelector";
import BottomButtonBox, { ButtomButtonBoxProps } from "../../BottomButtonBox";
import { MiniButtonType } from "../../MiniButton";

interface AccessibilityAnalysisProps {
    changeContent: (type: ContentList, reset?: boolean) => void;
    accState?: AccessibilityState;
    setAccState: (vehicle?: TransportMode, ready?: boolean) => void;
}

const AccessibilityAnalysis = (props: AccessibilityAnalysisProps) => {
    const [vehicle, setVehicle] = useState<TransportMode>(TransportMode.car);

    // 하단 버튼
    const buttonOptions: ButtomButtonBoxProps = {
        left: {
            label: "취소",
            type: MiniButtonType.GRAY,
            onClick: () => {
                props.changeContent(ContentList.Back, true);
            },
        },
        right: {
            label: "분석",
            onClick: () => {
                props.setAccState(vehicle);
                props.changeContent(ContentList.List);
            },
            type: vehicle && props.accState?.ready ? MiniButtonType.BLUE : MiniButtonType.DISABLED,
        },
    };

    return (
        <div className={`${styles.wrapper} undraggable`}>
            <ContentTitle title={"접근성 분석"} />
            <div className={styles.container}>
                <div className={styles.top}>
                    <div className={styles.content}>
                        <div className={styles.title}>{"분석 범위 설정"}</div>
                        <div className={styles.desc}>{"모든 분석 지점으로부터 동일한 시간 내 접근 가능한 범위를 표현합니다. (최대 30분)"}</div>
                        <div className={styles.desc}>{"이동수단을 선택하고 지도 화면에서 분석 대상 지점을 선택해주세요."}</div>
                        <div className={styles.desc}>{"(분석 대상 지점은 2개 이상 5개 이하 선택 가능)"}</div>
                    </div>
                </div>
                <div className={styles.middle}>
                    <div className={styles.content}>
                        <span className={styles.title}>{"이동 수단"}</span>
                        <TransportSelector selectedMode={vehicle} setSelectedMode={setVehicle} availableModes={[TransportMode.car]}/>
                    </div>
                </div>
            </div>
            <div className={styles.bottom}>
                <BottomButtonBox {...buttonOptions} />
            </div>
        </div>
    );
};

export default AccessibilityAnalysis;
